import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NestedLink } from '@app/_interfaces/nested-link';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '@app/_services/shared.service';
import { TouchClickDirective } from '../../../../shared/directives/touch-click.directive';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-dropdown-categories',
    templateUrl: './dropdown-categories.component.html',
    styleUrls: ['./dropdown-categories.component.scss'],
    standalone: true,
    imports: [NgClass, NgFor, NgIf, IconComponent, RouterLink, TouchClickDirective, NgTemplateOutlet]
})
export class DropdownCategoriesComponent implements OnInit {

    @Input() layout: 'classic' | 'topbar' = 'classic';
    @Input() items: any = [];
    @Output() itemClick: EventEmitter<NestedLink> = new EventEmitter<NestedLink>();

    hoveredItem: NestedLink = null;
    reCalcSubmenuPosition = false;
    constructor(private shareService: SharedService, public translate: TranslateService) { this.sector = this.shareService.page;}
    sector;
    ngOnInit(): void {
    }
    onMouseLeave(): void {
        this.hoveredItem = null;
    }
    onItemMouseEnter(item: NestedLink): void {
        if (this.hoveredItem !== item) {
            this.hoveredItem = item;

            if (item.items) {
                this.reCalcSubmenuPosition = true;
            }
        }
    }
    onSubItemClick(item: NestedLink): void {
        this.hoveredItem = null;
        this.itemClick.emit(item);
    }
    onTouchClick(event, item: NestedLink): void {
        if (event.cancelable) {
            if (this.hoveredItem && this.hoveredItem === item) {
                return;
            }

            if (item.items) {
                event.preventDefault();

                this.hoveredItem = item;
                this.reCalcSubmenuPosition = true;
            }
        }
    }
}
